import request from 'superagent';
import ContestFinalistStore from '../stores/contest-finalist-store';
import ContestStore from '../../../stores/contest-store';
import trackEvent from '@99designs/utils/platform/trackEvent';

export function addFinalist(context, user, done) {
    context.dispatch('ADD_FINALIST', user);
    const store = context.getStore(ContestFinalistStore);

    request
        .post(store.getPersistFinalistUrl())
        .timeout(10000)
        .type('form')
        .send({ userId: user.userId })
        .end((err, res) => {
            if (err) {
                context.dispatch('ADD_FINALIST_ERROR', res);
            } else {
                context.dispatch('ADD_FINALIST_SUCCESS');
            }
            done();
        });

    trackEvent('Added designer to finalist drawer', {
        stage: context.getStore(ContestStore).getStage(),
    });
}

export function removeFinalist(context, userId, done) {
    context.dispatch('REMOVE_FINALIST', userId);
    const store = context.getStore(ContestFinalistStore);

    request
        .delete(store.getPersistFinalistUrl())
        .timeout(10000)
        .type('form')
        .send({ userId: userId })
        .end((err, res) => {
            if (err) {
                context.dispatch('REMOVE_FINALIST_ERROR', res);
            } else {
                context.dispatch('REMOVE_FINALIST_SUCCESS');
            }
            done();
        });

    trackEvent('Removed designer from finalist drawer', {
        stage: context.getStore(ContestStore).getStage(),
    });
}



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/actions/contest-finalist.js